import { Flame, Lock, Percent, ShieldCheck, Users } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const CELLS = [
  {
    icon: Percent,
    label: "BUY / SELL TAX",
    value: "0 / 0",
    note: "The only thing getting slapped is the buy button.",
  },
  {
    icon: Flame,
    label: "LIQUIDITY",
    value: "100% BURNED",
    note: "Burned harder than your last bag.",
  },
  {
    icon: Lock,
    label: "MINT AUTHORITY",
    value: "REVOKED",
    note: "No new tokens. The cheeks are finite.",
  },
  {
    icon: ShieldCheck,
    label: "FREEZE AUTHORITY",
    value: "REVOKED",
    note: "Your bag. Unfreezable.",
  },
];

export default function Tokenomics() {
  return (
    <section id="tokenomics" data-testid="tokenomics-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading index="02" eyebrow="TOKENOMICS" title="THICC SUPPLY, ZERO GAMES" testId="tokenomics-heading" />
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-[#9fb39f] sm:text-base">
            Simple. Brutal. Final. Numbers below are the launch configuration
            for $PEPEBUTT — nothing hidden behind the cheeks.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-4">
          <Reveal
            className="flex flex-col justify-between border border-neon/50 bg-surface p-8 shadow-[inset_0_0_30px_rgba(57,255,20,0.05)] md:col-span-2 md:row-span-2"
            data-testid="tokenomics-supply-cell"
          >
            <div>
              <p className="font-mono text-[11px] tracking-[0.25em] text-neon uppercase">
                TOTAL SUPPLY
              </p>
              <p className="glow-neon mt-6 font-vt text-4xl leading-none text-[#EDEDE4] sm:text-5xl lg:text-6xl">
                1,000,000,000
              </p>
            </div>
            <p className="mt-8 font-mono text-xs leading-relaxed text-[#6b7f6b]">
              One billion $PEPEBUTT. Fixed forever. Pepe doesn't print — he
              claps.
            </p>
          </Reveal>

          {CELLS.map((c, i) => (
            <Reveal
              key={c.label}
              delay={0.08 * (i + 1)}
              className="group border border-line bg-nox p-6 transition-colors duration-300 hover:border-neon/60"
              data-testid={`tokenomics-cell-${c.label.toLowerCase().replace(/[\s/]+/g, "-")}`}
            >
              <c.icon size={18} className="text-neon" />
              <p className="mt-4 font-vt text-3xl text-[#EDEDE4]">{c.value}</p>
              <p className="mt-1 font-mono text-[10px] tracking-[0.2em] text-[#9fb39f] uppercase">
                {c.label}
              </p>
              <p className="mt-3 text-xs leading-relaxed text-[#6b7f6b]">{c.note}</p>
            </Reveal>
          ))}

          <Reveal
            delay={0.4}
            className="flex items-center gap-4 border border-line bg-nox p-6 md:col-span-2"
            data-testid="tokenomics-community-cell"
          >
            <Users size={18} className="shrink-0 text-neon" />
            <p className="text-xs leading-relaxed text-[#9fb39f] sm:text-sm">
              100% fair launch to the community. No presale, no team bags —
              everyone cheeks up together.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
